// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-style {
  color: #fff;
  background-color: #004f87;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
}

.accordion-button::after {
  display: none;
}

`, "",{"version":3,"sources":["webpack://./src/app/tab-expertise/tab-expertise.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".accordion-style {\n  color: #fff;\n  background-color: #004f87;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  border-radius: 0.25rem;\n}\n\n.accordion-button::after {\n  display: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
